var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgDeleteWarning(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.6155 19.9997C7.168 19.9997 6.78683 19.8424 6.472 19.5277C6.15733 19.2129 6 18.8317 6 18.3842V5.99972H5V4.99972H9V4.23047H15V4.99972H19V5.99972H18V18.3842C18 18.8446 17.8458 19.2289 17.5375 19.5372C17.2292 19.8456 16.8448 19.9997 16.3845 19.9997H7.6155ZM17 5.99972H7V18.3842C7 18.5637 7.05767 18.7112 7.173 18.8267C7.2885 18.9421 7.436 18.9997 7.6155 18.9997H16.3845C16.5385 18.9997 16.6796 18.9356 16.8077 18.8075C16.9359 18.6793 17 18.5382 17 18.3842V5.99972ZM9.80775 16.9997H10.8078V7.99972H9.80775V16.9997ZM13.1923 16.9997H14.1923V7.99972H13.1923V16.9997Z",
    fill: "currentColor"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgDeleteWarning);
export default __webpack_public_path__ + "static/media/delete-warning.6ec6f11ed5a428603c819749959138b9.svg";
export { ForwardRef as ReactComponent };